import React from 'react';
import { Flex } from 'antd';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { TargetRespondent } from 'jf/api';
import { useDevExTheme } from 'jf/common/themes/DevExTheme';
import { DevExAlert } from 'jf/components/DevExAlert';
import { DevExButton } from 'jf/components/DevExButton';
import { DevExText } from 'jf/components/DevExText';

type UnlinkedUserWarningProps = {
  unlinkedUsers: TargetRespondent[];
  enabled: boolean;
  onClick: () => void;
  messagingType: string;
};

export const UnlinkedUserWarning: React.FC<UnlinkedUserWarningProps> = ({
  unlinkedUsers,
  onClick,
  enabled,
  messagingType,
}) => {
  const theme = useDevExTheme();

  return (
    <DevExAlert
      message={
        <Flex gap={theme.variable.spacing.sm} align="center">
          <DevExText lined>
            <strong>
              {unlinkedUsers.length} {unlinkedUsers.length === 1 ? 'person ' : 'people '}
            </strong>
            from your roster {unlinkedUsers.length === 1 ? "doesn't" : "don't"} have {messagingType}{' '}
            linked to their profile and won't receive this survey unless you link one now.
          </DevExText>
          <DevExButton type="link" onClick={() => onClick()}>
            {enabled ? 'Hide unlinked users' : 'Link users'}
          </DevExButton>
        </Flex>
      }
      icon={<FontAwesomeIcon color={theme.color.status.warning.text} icon={faExclamationCircle} />}
      showIcon
      type="warning"
    />
  );
};
